import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex min-vh-100 flex-column" }
const _hoisted_2 = { id: "main" }

import MainHeader from '@/components/layouts/MainHeader.vue';
import MainFooter from '@/components/layouts/MainFooter.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainHeader),
    _createElementVNode("main", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(MainFooter)
  ]))
}
}

})